import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { AncillaryServices } from './pages/AncillaryServices';
import { UtilizationReview } from './pages/UtilizationReview';
import { MedicalBillReview } from './pages/MedicalBillReview';
import { CaseManagement } from './pages/CaseManagement';
import { MedicalTriageNurse } from './pages/MedicalTriageNurse';
import { Privacy } from './pages/Privacy';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        setTimeout(() => el.scrollIntoView({
          behavior: 'smooth'
        }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-brand-paper" data-id="element-2">
        <Navbar data-id="element-3" />
        <main data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<About data-id="element-9" />} data-id="element-8" />
            <Route path="/contact" element={<Contact data-id="element-11" />} data-id="element-10" />
            <Route path="/services/ancillary" element={<AncillaryServices data-id="element-13" />} data-id="element-12" />
            <Route path="/services/utilization-review" element={<UtilizationReview data-id="element-15" />} data-id="element-14" />
            <Route path="/services/bill-review" element={<MedicalBillReview data-id="element-17" />} data-id="element-16" />
            <Route path="/services/case-management" element={<CaseManagement data-id="element-19" />} data-id="element-18" />
            <Route path="/services/triage" element={<MedicalTriageNurse data-id="element-21" />} data-id="element-20" />
            <Route path="/privacy" element={<Privacy data-id="element-23" />} data-id="element-22" />
          </Routes>
        </main>
        <Footer data-id="element-24" />
      </div>
    </BrowserRouter>;
}